import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export default function ContactSection() {
  return (
    <section className="bg-gray-50 py-12 px-4">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden grid md:grid-cols-2 gap-6">

        {/* LEFT CONTENT */}
        <div className="p-8 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">
            Meruram India Tag Pvt. Ltd.
          </h2>

          <div className="flex items-start gap-4">
            <FaMapMarkerAlt className="text-red-500 text-xl mt-1" />
            <p className="text-gray-600 leading-relaxed">
              SN. 19A/3B, K.K. Market, Dhankawadi,<br />
              Pune City, Pune – 411043,<br />
              Maharashtra, India
            </p>
          </div>

          <div className="flex items-center gap-4">
            <FaPhoneAlt className="text-green-600 text-lg" />
            <a
              href="tel:+918275547499"
              className="text-gray-700 font-medium hover:text-green-600 transition"
            >
              +91 8275547499
            </a>
          </div>

          <div className="flex items-center gap-4">
            <FaEnvelope className="text-blue-500 text-lg" />
            <a
              href="mailto:meruramit@gmail.com"
              className="text-gray-700 font-medium hover:text-blue-600 transition"
            >
              meruramit@gmail.com
            </a>
          </div>
        </div>

        {/* RIGHT MAP */}
        <div className="w-full h-[320px] md:h-full">
          <iframe
            title="Meruram India Tag Pvt. Ltd Location"
            src="https://www.google.com/maps?q=K.K.%20Market%20Dhankawadi%20Pune%20411043&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

      </div>
    </section>
  );
}
